import React from "react";
import { Passengers } from "../OrderDetail/Passengers";

function RefundConfirmationPassengers({ data }) {
  const passengerIds = data?.passengerIds || [];
  return (
    <div className="w-full">
      <Passengers
        order={{
          booking: {
            flightBooking: [
              {
                ...data?.flightBooking,
                travelers: (data?.flightBooking?.travelers || [])?.filter(
                  (traveller) => passengerIds?.includes(traveller?.id),
                ),
              },
            ],
          },
        }}
      />
    </div>
  );
}

export default RefundConfirmationPassengers;
